import React, { useState, useEffect } from "react";
import GlobalStyles from "./../styles/GlobalStyles";
import Footer from "./Footer/Footer";
import Navbar from "./Navbar/Navbar";
import { globalHistory } from "@reach/router";

const Layout = ({ children, ...rest }) => {
  const [isHome, SetisHome] = useState(false);

  useEffect(() => {
    const path = globalHistory.location.pathname;
    console.log();

    if (path === "/") {
      SetisHome(true);
    } else {
      SetisHome(false);
    }
  }, []);

  return (
    <div {...rest}>
      <Navbar isHashLink={isHome} />
      <GlobalStyles />
      {children}
      <Footer />
    </div>
  );
};

export default Layout;
